import AddIcon from "@mui/icons-material/Add";
import { Button, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";

import { MobileVisitDraftCard } from "./MobileVisitDraftCard";
import { type VisitDraft } from "./visitDraft";

interface Props {
  drafts: VisitDraft[];
  onAddAnother: () => void;
  onEditDraft: (draftId: string) => void;
  onRemoveDraft: (draftId: string) => void;
}

const addButtonSx = {
  borderRadius: "24px",
  py: 1.5,
  textTransform: "none",
  fontSize: "1rem",
} as const;

/** The care-team review screen: every visit added so far, each editable/removable. */
export function MobileCareTeamReview({ drafts, onAddAnother, onEditDraft, onRemoveDraft }: Props) {
  return (
    <Stack spacing={2}>
      <Stack spacing={0.5}>
        <Text semibold variant="body1">
          Care team for this case
        </Text>
        <Text variant="body2" sx={{ color: "text.secondary" }}>
          Add a visit for each professional this patient needs.
        </Text>
      </Stack>

      {drafts.length === 0 ? (
        <Stack alignItems="center" justifyContent="center" sx={{ minHeight: "20vh" }}>
          <Text variant="body1" sx={(theme) => ({ color: theme.palette.text.disabled })}>
            No visits added yet
          </Text>
        </Stack>
      ) : (
        <Stack spacing={2}>
          {drafts.map((draft) => (
            <MobileVisitDraftCard
              key={draft.id}
              draft={draft}
              onEdit={() => {
                onEditDraft(draft.id);
              }}
              onRemove={() => {
                onRemoveDraft(draft.id);
              }}
            />
          ))}
        </Stack>
      )}

      <Button
        fullWidth
        variant="secondary"
        startIcon={<AddIcon />}
        onClick={onAddAnother}
        sx={addButtonSx}
      >
        Add another visit
      </Button>
    </Stack>
  );
}
